/**************
 Global
 ***************/

// root url
//const root = "http://localhost:3000";
const root = "https://api.lowaboots.com";

// url search params
const urlParams = new URLSearchParams(window.location.search);

// initialize all tippy tooltips
tippy('[data-tippy-content]');

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// is number
function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

// search function
function search(query) {
    // check if query is a style number. style number is 10 digits long OR starts with "LS"
    if ((isNumber(query) && query.length === 10) || query.startsWith("LS")) {
        // create search params
        const filters = new URLSearchParams({
            "filter.v.m.maltertech.style_number": query,
            "filter.v.availability": "1"
        })

        // redirect to collection page
        window.location.href = `/collections/all?${filters.toString()}`;
    } else {
        // create search params
        const filters = new URLSearchParams({
            "q": query,
            "type": "product",
            "options[unavailable_products]": "hide"
        })

        // redirect to search page
        window.location.href = `/search?${filters.toString()}`;
    }
}

document.querySelectorAll(`form[action="/search"]`).forEach(form => {
    form.addEventListener("submit", e => {
        e.preventDefault();

        // get query
        const query = e.target.querySelector(`[name="q"]`).value;

        // initiate search
        search(query);
    });
});